<div class="card welcome-ke">
  <!-- <div class="welcome-banner d-flex justify-content-between align-items-center">
    <img src="assets/images/Wooden-Boat-at-ERR.jpg" />
  </div> -->
  <!-- <div class="welcome-header d-flex justify-content-between align-items-center">
    <strong>Courtesy Statement</strong>
    <img src="assets/images/default-burgee.jpg" />
  </div> -->
  <hr />  
  <!-- <p>
    <strong>Courtesy Statement</strong>
  </p> -->
  <p>
    Welcome to P-Type! 
  </p>
  <div style="text-align: right;">
    <button class="ui-button-success" pButton type="button" label="Got it!" icon="pi pi-check" style="margin:10px;"
      (click)="recordAck()"></button>
  </div>
</div>